// extracted by mini-css-extract-plugin
export default {"container":"RoleSelect_container_bfea1","label":"RoleSelect_label_d1109","disabled":"RoleSelect_disabled_bf684"};